jQuery(document).ready(function () {
    AOS.init({
        anchorPlacement: 'center-center',
        duration: 1500,
        disable: 'mobile'
    });

    jQuery('.panel a').click(function() {
        jQuery('.panel').removeClass('active');
        if(!jQuery(this).closest('.panel').find('.panel-collapse').hasClass('in'))
            jQuery(this).closest('.panel').addClass('active');
    });
});
